module.exports = __webpack_public_path__ + "8cb0436c4b4f3fdcceb4a864551e9e2f.png";